/* Birthday is in short date MM/DD/YYYY format */

export const data = [
    {
        id: 1,
        firstName: "Simon",
        age: "38",
        dob: "02/03/1983",
        image: "https://www.zoosk.com/date-mix/wp-content/uploads/2018/05/avatar_user_134_1525211178-164x164.jpg",
    },
    {
        id: 2,
        firstName: "Mary",
        age: "78",
        dob: "05/09/1943",
        image: "https://cdn2.stylecraze.com/wp-content/uploads/2013/02/50-Simple-Office-Hairstyles-For-Women-1-150x150.jpg",
    },
    {
        id: 3,
        firstName: "Tommy",
        age: "14",
        dob: "08/11/2006",
        image: "https://thumbs.dreamstime.com/t/portrait-man-gray-hair-gray-beard-close-up-73275269.jpg",
    },
];
